import React, { useState } from "react";
import parcoursData from "./parcoursData";
import bookDatabase from "./bookDatabase";
import amazonLogo from "./assets/amazon-icon.png";
import getFilteredBooks from "./getFilteredBooks";
import "./Questionnaire.css";
import MinimalNavbar from "./MinimalNavbar";
import "./styles/backgrounds.css"; // ← si ce fichier est bien placé dans ton projet



const normalize = (text) =>
  text?.toString().toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/’/g, "'").trim();

export const Questionnaire = () => {
  const [step, setStep] = useState(0);
  const isResults = step >= 6;
  const [answers, setAnswers] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  const handleAnswer = (answer) => {
  if (step === 3) {
    const tagAlreadySelected = selectedTags.includes(answer);
    if (tagAlreadySelected) {
      setSelectedTags(selectedTags.filter((tag) => tag !== answer));
    } else if (selectedTags.length < 5) {
      setSelectedTags([...selectedTags, answer]);
    }
  } else {
    const newAnswers = [...answers, answer];
    setAnswers(newAnswers);

    setTimeout(() => {
      const allButtons = document.querySelectorAll(".answer-button");
      allButtons.forEach((btn) => {
        if (btn.textContent.includes(answer)) {
          btn.classList.add("selected");
        }
      });
    }, 0);

    if (step === 2) {
  setSelectedTags([]);      // ✅ on vide la sélection à l’arrivée sur la page des tags
  setStep(3);               // on passe à l’étape des tags
} else {
  setStep(step + 1);
}

  }
};

  const handleNextFromTags = () => {
    setAnswers([...answers, selectedTags]);
    setStep(6);
  };

// Permet de revenir sur la sélection des tags depuis les résultats
  const goBackToTags = () => {
  // Les tags validés sont stockés dans answers[3] par handleNextFromTags
  const previousTags = Array.isArray(answers[3]) ? answers[3] : [];
  // On coupe l'historique pour ne garder que Catégorie 1, 2, 3
  setAnswers(answers.slice(0, 3));
  // On restaure la sélection de tags
  setSelectedTags(previousTags);
  // On revient à l'étape des tags
  setStep(3);
};

  const handlePrevious = () => {
  // ✅ si on QUITTE la page des tags (étape 3 → étape 2), on vide la sélection
  if (step === 3) {
    setSelectedTags([]);
  }

  // ✅ si on avait déjà validé des tags (answers[3]) et qu’on revient en arrière
  if (answers.length === 4) {
    setSelectedTags([]);
  }

  if (step > 0) {
    setAnswers(answers.slice(0, -1));
    setStep(step - 1);
  }
};


  const getBooksAfter3Steps = () => {
    if (answers.length < 3) return [];
    return bookDatabase.filter((book) =>
      normalize(book.category1) === normalize(answers[0]) &&
      normalize(book.category2) === normalize(answers[1]) &&
      normalize(book.category3) === normalize(answers[2])
    );
  };

  const getTagOptions = () => {
    let tempAnswers = [...answers];

    // si on est à l'étape 3 et que la 3e réponse n'est pas encore enregistrée
    if (step === 3 && tempAnswers.length === 2) {
  const allButtons = document.querySelectorAll(".answers-wrapper .answer-button");
  const lastClickedButton = [...allButtons].find((btn) =>
    btn.classList.contains("selected")
  );
  if (lastClickedButton) {
    const guessedAnswer = lastClickedButton.textContent.trim().split("\n")[0];
    tempAnswers.push(guessedAnswer);
      }
    }

    const books = bookDatabase.filter((book) =>
      normalize(book.category1) === normalize(tempAnswers[0]) &&
      normalize(book.category2) === normalize(tempAnswers[1]) &&
      normalize(book.category3) === normalize(tempAnswers[2])
    );

    const allTags = books.flatMap((book) => book.tags?.split(",") || []);
    const uniqueTags = [...new Set(allTags.map((tag) => tag.trim()).filter(Boolean))];
    return uniqueTags;
  };

  const getQuestionLabel = (step) => {
    switch (step) {
      case 0:
        return "Qu'attendez vous de votre prochain livre ?";
      case 1:
        return "Quel domaine vous intéresse le plus ?";
      case 2:
        return "Un thème en particulier ?";
      case 3:
        return "Quels mots-clés vous parlent ? (Max 5 puis Valider)";
      default:
        return "";
    }
  };

  const getAnswerOptions = () => {
    if (step === 3) {
      return getTagOptions().map((tag) => ({
        title: tag,
        pitch: ""
      }));
    }

    const allOptions = [];
    const seenCombinations = new Set();

    parcoursData.forEach((item) => {
      let title, pitch, comboKey;

      if (step < 3) {
        const titreKey = `Catégorie ${step + 1} - Titre`;
        const pitchKey = `Catégorie ${step + 1} - Pitch`;
        title = item[titreKey]?.trim();
        pitch = item[pitchKey]?.trim();
        comboKey = `${title}|${pitch}`;
      }

      let isValid = true;
      for (let i = 0; i < step; i++) {
        const previousKey = i < 3 ? `Catégorie ${i + 1} - Titre` : "Catégorie 4";
        if (normalize(item[previousKey]) !== normalize(answers[i])) {
          isValid = false;
          break;
        }
      }

      if (isValid && title && !seenCombinations.has(comboKey)) {
        seenCombinations.add(comboKey);
        allOptions.push({ title, pitch });
      }
    });

    return allOptions;
  };

  const filteredBooks = getFilteredBooks(bookDatabase, answers);

  const questionnaireContent = step >= 6 ? (
    <>
      {/* ✅ Bandeau d'action pour revenir aux tags */}
   
      <h2 className="question-title">Vos recommandations de lecture :</h2>
      {answers.length > 0 && (
        <div className="previous-answers">
          <h3>Réponses données :</h3>
          <ul>
            {answers.map((ans, idx) => (
              <li key={idx}>{Array.isArray(ans) ? ans.join(", ") : ans}</li>
            ))}
          </ul>
        </div>
      )}

 <div className="results-actions">
      <button className="back-button" onClick={goBackToTags}>
        ⬅️ Modifier les tags
      </button>
    </div>

      {filteredBooks.length > 0 ? (
        filteredBooks.map((book, index) => (
          <div className="recommendation" key={index}>
            <div className="recommendation-cover">
              {book.cover && (
                <img
                  src={book.cover}
                  alt={`Couverture de ${book.title}`}
                  className="cover-image"
                />
              )}
            </div>
            <div className="recommendation-content">
                <h3>{index === 0 && "⭐⭐⭐ "}
                {index === 1 && "⭐⭐ "}
                {index === 2 && "⭐ "}
              {book.title}</h3>
              <div className="recommendation-meta">
                ✍ {book.author}
                {book.nbp && <> • 📖 {book.nbp} pages</>}
              </div>
              <div className="recommendation-summary">{book.summary}</div>
              {book.url && (
                <a
                  className="amazon-link"
                  href={book.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={amazonLogo} alt="Amazon" />
                  Consulter sur Amazon
                </a>
              )}
            </div>
          </div>
        ))
      ) : (
        <p>Aucun livre ne correspond exactement à ce parcours. Essayez d'autres combinaisons !</p>
      )}

      <button className="answer-button" onClick={() => {
        setStep(0);
        setAnswers([]);
        setSelectedTags([]);
      }}>
        🔄 Recommencer
      </button>
    </>
  ) : (
    <>
      <h2 className="question-title">{getQuestionLabel(step)}</h2>
      <div className={`answers-wrapper ${step === 3 ? "tag-grid" : ""}`}>
        {getAnswerOptions().map((answer, index) => (
          <button
            key={index}
            className={`answer-button ${step === 3 && selectedTags.includes(answer.title) ? "selected" : ""}`}
            onClick={() => handleAnswer(answer.title)}
          >
            <strong>{answer.title}</strong><br />
            <span style={{ fontSize: '0.9rem' }}>{answer.pitch}</span>
          </button>
        ))}
        {step === 3 && (
          <button
            className="answer-button validate-tags"
            onClick={handleNextFromTags}
            disabled={selectedTags.length === 0}
          >
            ✅ Valider {selectedTags.length} tag{selectedTags.length > 1 ? "s" : ""}
          </button>
        )}
        {step > 0 && (
          <button className="back-button" onClick={handlePrevious}>
            ⬅️ Question précédente
          </button>
        )}
      </div>
      {answers.length > 0 && (
        <div className="previous-answers">
          <h3>Réponses précédentes :</h3>
          <ul>
            {answers.map((ans, idx) => (
              <li key={idx}>{Array.isArray(ans) ? ans.join(", ") : ans}</li>
            ))}
          </ul>
        </div>
      )}
    </>
  );

  return (
    <>
      <div className="navbar-container">
        <MinimalNavbar />
      </div>
<div className={isResults ? "results-background" : "page-background quiz-background"}>
  <div className={`questionnaire-content-wrapper ${isResults ? 'no-padding' : ''}`}>
    {questionnaireContent}
  </div>
</div>

    </>
  );
};
